import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Heading',
    props: {
        h1: { type: Boolean },
        h2: { type: Boolean },
        h3: { type: Boolean },
        h4: { type: Boolean },
        h5: { type: Boolean },
        h6: { type: Boolean },
        bold: { type: Boolean },
        separator: { type: Boolean },
        inline: { type: Boolean },
        size: null,
        icon: null
    },
    setup(__props) {
        const props = __props;
        const sizeClass = computed(() => {
            var _a;
            return `h-${(_a = props.size) !== null && _a !== void 0 ? _a : "lg"}`;
        });
        const element = computed(() => {
            for (const key of ["h1", "h2", "h3", "h4", "h5", "h6"]) {
                if (props[key]) {
                    return key;
                }
            }
            return "h1";
        });
        return { __sfc: true, props, sizeClass, element, FontAwesomeIcon };
    }
});
